import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingController } from '@ionic/angular/standalone';
import { forkJoin, from } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

export const loadingInterceptor: HttpInterceptorFn = (request, next) => {
  const loadingController = inject(LoadingController);
  const loadingInstances = [];

  if (request.headers.has('ignoreLoading')) {
    return next(request.clone({ headers: request.headers.delete('ignoreLoading') }));
  }

  const id = (Math.random() + 1).toString(36).slice(2, 7);
  const $r = next(request);
  const $loading = from(
    loadingController.create({ id, cssClass: 'request-loading', backdropDismiss: true, showBackdrop: false }).then(ref => {
      if (ref) {
        loadingInstances.push(ref);
        ref.present();
      }
    })
  );

  return forkJoin([$r, $loading]).pipe(
    map(([event, _]) => event),
    finalize(() => {
      while (loadingInstances.length > 0) {
        loadingInstances.pop().dismiss();
      }
    })
  );
};
